import { DefaultOptions, QueryClient } from "react-query";

const options: DefaultOptions = {
  queries: {
    retry: 2,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  },
};

export const queryClient = new QueryClient({
  defaultOptions: options,
});
